interface TopBarProps {
  activePage: string;
}

const NAV_ITEMS = [
  { key: 'dashboard', label: 'Dashboard', href: '/' },
  { key: 'database', label: 'Database', href: '/database' },
  { key: 'staging', label: 'Staging', href: '/staging' },
  { key: 'queue', label: 'Queue', href: '/queue' },
  { key: 'history', label: 'History', href: '/history' },
];

export function TopBar({ activePage }: TopBarProps) {
  return (
    <div class="topbar">
      <div class="topbar-left">
        <div class="topbar-pill"></div>
        <div class="topbar-logo-bar">
          <span class="topbar-logo">TPA Command Centre</span>
        </div>
      </div>
      <div class="topbar-nav-section">
        <div class="topbar-nav-bar">
          <nav class="topbar-nav">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.key}
                href={item.href}
                class={activePage === item.key ? 'active' : ''}
              >
                {item.label}
              </a>
            ))}
            <a href="#" class="dim">Calendar</a>
            <a href="#" class="dim">Analytics</a>
          </nav>
        </div>
      </div>
      <div class="topbar-status">
        <span class="status-pip"></span>
        PIPELINE NOMINAL
      </div>
    </div>
  );
}
